import { AccountPackageService } from 'src/app/services/account/account-package.service';
import { StorageService } from './storage.service';
import { AccountTaskService } from 'src/app/services/account/account-task.service';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { RateApp } from 'capacitor-rate-app';
import { Platform } from '@ionic/angular';
import { DebugModeService } from './debug-mode.service';
import { GuestSummaryService } from '../guest/guest-summary.service';
import { FunctionService } from './function.service';

@Injectable({
  providedIn: 'root'
})
export class AppRateService implements OnInit, OnDestroy {

  private appRate: boolean;

  constructor(
    private platform: Platform,
    private guestSummaryService: GuestSummaryService,
    private debugModeService: DebugModeService,
    private storageService: StorageService,
    private functionService: FunctionService,
  ) {
    this.readAppRate();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  async readAppRate() {
    await this.platform.ready();
    this.appRate = await this.storageService.get('app_rate') ? true : false;
  }

  async getAppRate() {
    await this.readAppRate();
    return this.appRate;
  }

  async setAppRate(appRate: boolean) {
    this.appRate = appRate;
    this.storageService.set('app_rate', this.appRate);
  }

  async checkAppRate() {
    if (this.platform.is('hybrid') && !this.debugModeService.debugMode && !this.appRate) {
      await this.functionService.delay(10000);
      this.promptAppRate();
    }
  }

  async promptAppRate() {
    await RateApp.requestReview();
    await this.setAppRate(true);
  }

  /**
   * Get guest list count by criteria
   */
  getGuestListCount(): number {
    return this.guestSummaryService.getGuestListCount(null, null, null, null, null, null, null, { checkin: true }, 'checkin');
  }

  /**
   * Get total count of current card type
   * @param all all card of current card type
   */
  getTotalCount(): number {
    return this.guestSummaryService.getGuestListCount(null, null, null, null, null, null, null, null, 'checkin');
  }

  /**
   * Calculate percentage
   * @param value count
   * @param total total
   */
  getPercentCount(value: number, total: number): number {
    let percent = 0;
    if (value && total) {
      percent = Math.round((value / total) * 100);
    }
    return percent;
  }
}
